export const GWT_GET_APPLICATION_ID_FAILED = 'GWT_GET_APPLICATION_ID_FAILED';
export const GWT_GET_APPLICATION_ID_START = 'GWT_GET_APPLICATION_ID_START';
export const GWT_GET_APPLICATION_ID_SUCCESS = 'GWT_GET_APPLICATION_ID_SUCCESS';
export const SHOW_CHICKEN_EXIT = 'SHOW_CHICKEN_EXIT';
export const SET_IS_MESSAGE_FORM_DIRTY = 'SET_IS_MESSAGE_FORM_DIRTY';
export const SHOW_FIND_RECORDING_MODAL = 'SHOW_FIND_RECORDING_MODAL';
export const SET_FIND_RECORDING_MODAL_LANG = 'SET_FIND_RECORDING_MODAL_LANG';
export const SET_FIND_RECORDING_FIELD_ID = 'SET_FIND_RECORDING_FIELD_ID';

export function setShowChickenExit(showChickenExit) {
  return {
    type: SHOW_CHICKEN_EXIT,
    payload: showChickenExit,
  };
}

export function setIsMessageFormDirty(isMessageFormDirty) {
  return {
    type: SET_IS_MESSAGE_FORM_DIRTY,
    payload: isMessageFormDirty,
  };
}

export function setFindRecordingModalLanguage(setFindRecordingLanguage) {
  return {
    type: SET_FIND_RECORDING_MODAL_LANG,
    payload: setFindRecordingLanguage,
  };
}

export function setFindRecordingModalFieldId(setFindRecordingFieldId) {
  return {
    type: SET_FIND_RECORDING_FIELD_ID,
    payload: setFindRecordingFieldId,
  };
}
